import * as React from "react";
import { SecuredSearch } from "./SecuredSearch";
import { SecuredCustomNavigation } from "./CustomNavigation/SecuredCustomNavigation";
import { FirmLogoStore, UserStore } from "../Stroes/Variable";
import { FormComponent } from "../../../react-core/Html/FormComponent";
import { AddLogoAction } from "./Settings/AddLogo/Action/AddLogoAction";
import { CompanyLogo } from "../../../Wrap/Models/Domains/Company/CompanyLogo";
import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";
import { UIThemeAction } from "./Settings/Action/UIThemeAction";
import { JsonDateParser } from "../../../react-core/Utils/JsonDateParser";
import { LogoHeader } from "../../DLU/LogoHeader";
import { UserClient } from "../../../Wrap/Api/User/User";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { UserDispatcher } from "../Stroes/Variable";

interface ISecuredHeaderProps extends React.Props<SecuredHeader> {
    onClick?: (methodName: string, parameters?: any) => void;
}

interface ISecuredHeaderState {
    logoUrl: CompanyLogo;
    isLoading: boolean;
}

export class SecuredHeader extends FormComponent<ISecuredHeaderProps, ISecuredHeaderState> {
    constructor(props: any) {
        super(props);
        this.state = { logoUrl: null, isLoading: true };
        this.subscribeToStore(FirmLogoStore, () => this.onFirmLogoStoreChange());
    }

    componentDidMount() {
        const maybeUser = UserStore.getUserInfo();
        if (!maybeUser) {
            if (UserStore.getUserInfo() || UserStore.isLoading()) {
                return;
            }
            UserDispatcher.dispatch({ actionType: ActionType.Loading, payload: [] });
            const client = new UserClient();
            const promise = client.get();

            promise.onSuccess((result) => {
                UserDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: result,
                });
                this.getFirmLogo();
            });

            promise.onError((err) => {});
        } else {
            this.getFirmLogo();
        }
    }

    private getFirmLogo() {
        const data = FirmLogoStore.getFirmLogoInfo();

        const isAdmin = UserStore.getUserInfo()?.IsAdmin != null ? UserStore.getUserInfo().IsAdmin : true;
        if (CommonHelper.isNullOrEmpty(data)) {
            AddLogoAction.getLogo(isAdmin);
        } else {
            this.setState({ logoUrl: data, isLoading: false });
        }
    }

    private onFirmLogoStoreChange() {
        const data = FirmLogoStore.getFirmLogoInfo();
        this.setState({ logoUrl: data, isLoading: false });
    }

    public render(): JSX.Element {
        const userInfo = UserStore.getUserInfo();
        if (
            JsonDateParser.isValidDate(userInfo?.PasswordExpiredDate) &&
            userInfo?.PasswordExpiredDate <= JsonDateParser.toJsonDateNoOffset(new Date())
        ) {
            return <LogoHeader />;
        }
        const logoStyle = UIThemeAction.getLogoUrl(this.state.logoUrl);
        return (
            <header>
                <div className="container secured-header-inner">
                    {!this.state.isLoading && (
                        <a className="app-logo" style={logoStyle}>
                            {CommonHelper.isNullOrEmpty(this.state.logoUrl?.LocalUrl) &&
                                CommonHelper.isNullOrEmpty(this.state.logoUrl?.UploadUrl) && (
                                    <span className="sr-only">Abrdn Advisor platform</span>
                                )}
                        </a>
                    )}
                    {this.state.isLoading && <div className="app-logo-placeholder" />}
                    <div className="layout-secured-search-wrap">
                        <SecuredSearch />
                    </div>
                    <div className="layout-secured-custom-navigation-wrap">
                        <SecuredCustomNavigation />
                    </div>
                </div>
            </header>
        );
    }
}
